import axios, { CancelTokenSource } from 'axios'
import React, { useEffect, useRef, useState } from 'react'
import { IBookmarksSummary } from '../../../models/Bookmarks'
import BookmarksService from '../../../services/BookmarksService'
import Protected from '../../Protected'
import { BOOKMARKSTYPES } from '../bookmarkstypes'
import useErrorHandler from '../../../hooks/useErrorHandler'
import FormErrorDisplay from '../../common/FormErrorMessages'
import Conditional from '../../common/Conditional'
import Loader from '../../common/Loader'
import '../Bookmarks.css'
import { useHistory } from 'react-router-dom'
import { Button } from 'semantic-ui-react'
const pactBaseUrl = process.env.REACT_APP_PACT_URL
const govCMSUrl = process.env.REACT_APP_GOVCMS_HOME
const NoticeRedundancyResults = () => {
  const [data, setData] = useState<IBookmarksSummary[]>([])
  const [hasMore, sethasMore] = useState(false)
  const [isLoadingMore, setIsLoadingMore] = useState(false)
  const mountedRef = useRef(false)
  const [isLoading, setIsLoading] = useState(true)
  const [userErrors, handleErrors] = useErrorHandler()
  const size = 10
  const history = useHistory()
  const getNoticeRedundancuResults = async (source?: CancelTokenSource) => {
    await BookmarksService.getBookmarks(
      { offset: data.length, size: size },
      { type: BOOKMARKSTYPES.NOTICEREDUNDANCY },
      source
    ).then((response) => {
      if (mountedRef.current) {
        const res = response.result
        setData((old) => [...old, ...res.result])
        sethasMore(res.hasMore)
      }
    })
  }
  const loadMoreNoticeRedundancyResults = async () => {
    setIsLoadingMore(true)
    getNoticeRedundancuResults()
      .then(() => {
        setIsLoadingMore(false)
      })
      .catch((error) => {
        setIsLoadingMore(false)
        handleErrors(error)
      })
  }
  useEffect(() => {
    mountedRef.current = true
    const source = axios.CancelToken.source()
    getNoticeRedundancuResults(source)
      .then(() => {
        setIsLoading(false)
      })
      .catch((error) => {
        setIsLoading(false)
        handleErrors(error)
      })

    return () => {
      mountedRef.current = false
      if (source) {
        source.cancel('Operation cancelled')
      }
    }
  }, [])

  const deleteBookmark = (id: string) => {
    history.push('/my-account/bookmarks-delete?id=' + id + '&type=results')
  }
  return (
    <Protected>
      <Conditional if={isLoading}>
        <Loader />
      </Conditional>
      <div className="content-wrapper">
        <FormErrorDisplay
          show={userErrors?.length > 0}
          errorsList={userErrors}
        />
        <p></p>
        <h2>Notice and redundancy results</h2>
        <p></p>
        <Conditional if={data && data.length > 0}>
          <div className="table-wrapper">
            <table id="table-noticeresults">
              <thead>
                <tr>
                  <th>Date</th>
                  <th className="cell-width">Notice and redundancy results</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {data.length > 0 &&
                  data.map((item, index) => (
                    <tr key={index} className="cell-color">
                      <td>{item.createdOn}</td>
                      <td>
                        {' '}
                        <a href={item.sourceUrl} target="blank">
                          {item.title}
                        </a>
                      </td>
                      <td className="float-right">
                        <Button
                          className="ui is-secondary button"
                          onClick={() => deleteBookmark(item.id)}
                        >
                          Delete
                        </Button>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </Conditional>
        <Conditional if={hasMore}>
          <button
            onClick={loadMoreNoticeRedundancyResults}
            className="button is-primary"
            type="button"
            disabled={isLoadingMore}
          >
            Load more
          </button>
        </Conditional>
        <Conditional if={!hasMore && !isLoading && data.length > 0}>
          <p className="d-flex justify-content-center">
            <b>No more bookmarked notice and redundancy results</b>
          </p>
        </Conditional>
        <Conditional
          if={data.length <= 0 && !isLoading && userErrors?.length <= 0}
        >
          <p className="d-flex">
            You have no bookmarked notice and redundancy results from the&nbsp;
            <a href={pactBaseUrl + '/EndingEmployment'}>
              Notice and Redundancy Calculator
            </a>
            .
          </p>
          <p></p>
        </Conditional>
        <h2>Pay guides</h2>
        <p>
          To access minimum pay rates, allowances and penalty rates for an
          award, you can also download a{' '}
          <a href={govCMSUrl + '/pay-and-wages/minimum-wages/pay-guides'}>
            Pay guide
          </a>
          .
        </p>
        <p></p>
        <p>
          Pay rates may change from the first full pay period on or after 1 July
          each year. Be sure to use the{' '}
          <a href={pactBaseUrl + '/FindYourAward'}>Pay Calculator</a> and
          download the latest{' '}
          <a href={govCMSUrl + '/pay-and-wages/minimum-wages/pay-guides'}>
            Pay guide
          </a>{' '}
          to stay up to date.
        </p>
      </div>
    </Protected>
  )
}

export default NoticeRedundancyResults
